module.exports = __webpack_public_path__ + "img/selected6-min.06ac509c.png";